<template>
  <tr class="border-b text-left cursor-pointer hover:bg-gray-100">
    <td
      class="px-3 py-2 whitespace-nowrap"
      style="max-width: 8vw"
      @click="editImage"
    >
      <div class="text-sm text-gray-900 overflow-hidden truncate">
        {{ this.image.data.title }}
      </div>
    </td>
    <td class="px-3 py-2 whitespace-nowrap">
      <div
        class="text-sm font-medium text-gray-900 overflow-hidden flex flex-row items-center"
      >
        <img
          v-if="this.image.data.image_url.length === 0"
          class="inline-block h-10 w-10 square-full ring-2 ring-white"
          src="https://st3.depositphotos.com/23594922/31822/v/600/depositphotos_318221368-stock-illustration-missing-picture-page-for-website.jpg "
        />
        <img
          v-else
          class="inline-block h-10 w-10 square-full ring-2 ring-white"
          :src="this.image.data.image_url"
        />
        <a target="blank" :href="this.image.data.image_url">
          <IconLink class="ml-1 text-blue-400" />
        </a>
      </div>
    </td>
    <td class="px-3 py-2" style="max-width: 15vw" @click="editImage">
      <div class="text-sm text-gray-900">
        {{ productSkuList }}
      </div>
    </td>
    <td class="px-3 py-2" style="max-width: 15vw" @click="editImage">
      <div class="text-sm text-gray-900">
        {{ relatedSkuList }}
      </div>
    </td>
    <td class="px-3 py-2" style="max-width: 15vw" @click="editImage">
      <div class="text-sm text-gray-900">
        {{ tagList }}
      </div>
    </td>
    <td class="px-3 py-2 whitespace-nowrap" @click="editImage">
      <div class="text-sm text-gray-900">{{ dateAndTime }}</div>
    </td>
    <td
      class="px-3 py-2 whitespace-nowrap"
      style="max-width: 8vw"
      @click="editImage"
    >
      <div class="text-sm text-gray-900 overflow-hidden truncate">
        {{ this.image.data.modified_by }}
      </div>
    </td>
    <td class="px-3 py-2 whitespace-nowrap">
      <button
        @click="editImage"
        class="mr-2 inline-flex items-center text-gray-700 bg-white active:bg-gray-50 font-bold uppercase text-xs px-4 py-2 border border-gray-300 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
      >
        <IconPencil class="fill-gray" />
        Edit
      </button>
      <button
        @click="deleteImage"
        class="inline-flex items-center text-gray-700 bg-white active:bg-gray-50 font-bold uppercase text-xs px-4 py-2 border border-gray-300 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
      >
        <IconCircleCross class="fill-gray" />
        Delete
      </button>
    </td>
  </tr>
</template>

<script>
import * as Helpers from "@/helpers";
import IconLink from "@/assets/icons/IconLink";
import IconPencil from "@/assets/icons/IconPencil";
import IconCircleCross from "@/assets/icons/IconCircleCross";

export default {
  name: "ImageItemRow",
  components: {
    IconLink,
    IconPencil,
    IconCircleCross
  },
  props: {
    image: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    productSkuList() {
      let productSkuListData = [];
      this.image.data.product_skus.forEach((productSku) => {
        productSkuListData.push(productSku.label);
      });
      return productSkuListData.join(", ");
    },
    relatedSkuList() {
      let relatedSkuListData = [];
      this.image.data.related_skus.forEach((relatedSku) => {
        relatedSkuListData.push(relatedSku.label);
      });
      return relatedSkuListData.join(", ");
    },
    tagList() {
      let tagListData = [];
      this.image.data.tags.trend.forEach((tag) => {
        tagListData.push(tag.label);
      });
      this.image.data.tags.finish.forEach((tag) => {
        tagListData.push(tag.label);
      });
      this.image.data.tags.project.forEach((tag) => {
        tagListData.push(tag.label);
      });
      return tagListData.join(", ");
    },
    dateAndTime() {
      return Helpers.formatLocalDate(this.image.data.date_added);
    }
  },
  methods: {
    editImage() {
      this.$emit("imageEdit", this.image);
    },
    deleteImage() {
      this.$emit("imageDelete", this.image);
    }
  }
};
</script>
